<template>
    <div id="residence-application-submission">
        <v-card flat>
            <v-card-text>
                <v-alert v-if="submission == 'success'" class="text-center" :color="successColor" text prominent>
                    <h3>
                        <v-icon :color="successColor">mdi-check-circle</v-icon> Thank you for your application!
                    </h3>
                    <v-divider class="my-4 success__color"></v-divider>
                    An e-mail has been sent to the account you specified during registration, detailing important
                    information.<br>
                    Thank you for your interest in King's Residence.
                </v-alert>
                <v-alert v-else-if="submission == 'warning'" class="text-center" :color="warningColor" text prominent>
                    <h3>
                        <v-icon :color="warningColor">mdi-bell</v-icon> An application has already been submitted!
                    </h3>
                    <v-divider class="my-4 warning__color"></v-divider>
                    Our records show that you have already submitted an Online Residence Application for the residence
                    term:
                    {{ applicant.residenceTerm }}.
                </v-alert>
                <v-alert v-else class="text-center" :color="dangerColor" text prominent>
                    <h3>
                        <v-icon :color="dangerColor">mdi-alert-circle</v-icon> Your application could not be submitted!
                    </h3>
                    <v-divider class="my-4 danger__color"></v-divider>
                    Please contact us by e-mail at <a href="mailto:residence@kings.uwo.ca">residence@kings.uwo.ca</a>residence@kings.uwo.ca
                    or by telephone at
                    <b>1-800-265-4406 x4700</b>.
                </v-alert>
            </v-card-text>
        </v-card>
        <v-footer padless="true">
            <v-container fluid>
                <v-row>
                    <v-col cols="12" md="10">
                        <v-card flat>
                            <v-card-text>
                                Should you have any questions or concerns about your application, please contact the
                                <b>King's
                                    Residence Office</b> by e-mail at <a
                                    href="mailto:residence@kings.uwo.ca">residence@kings.uwo.ca</a> or by telephone at
                                <b>1-800-265-4406 x4700</b>.
                            </v-card-text>
                            <v-card-text>
                                While every attempt has been made to create a user-friendly site, which is accessible
                                and
                                contains
                                current information, we may have missed something! If so, please contact us and we would
                                be
                                pleased
                                to make any necessary improvements.
                            </v-card-text>
                            <v-card-text class="font-weight-medium">
                                King's University College<br>
                                at The University of Western Ontario<br>
                                266 Epworth Avenue, London, Ontario, N6A 2M3 • Tel: (519) 433-3491
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-card flat>
                            <v-card-text>
                                <v-img src="../../../../assets/backgrounds/kings_logo.jpg"></v-img>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-footer>
    </div>
</template>

<script>
export default {
    name: 'residence-application-submission',
    props: {
        applicant: {
            required: true,
            type: Object
        },
        submission: {
            required: true,
            type: String
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        successColor() {
            return '#1dc9b7';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>

<style scoped>
.danger__color {
    background-color: #f64e60 !important;
    border-color: #f64e60 !important;
}

.success__color {
    background-color: #1dc9b7 !important;
    border-color: #1dc9b7 !important;
}

.warning__color {
    background-color: #ffb822 !important;
    border-color: #ffb822 !important;
}

.v-footer {
    background: #fff;
    border-top: 1px solid #0e0e0e;
}
</style>